import request from "../../untils/request.js"


export const getOrdersByPatientId = (params) => {
    return request.get("/outpatient/api/v2/outpatient/orders", {params} )
}

export default{

}